import { getPinia } from '@/createPiniaSingleton';
import { useReportFiltersStore } from '@/stores/reports/useReportFiltersStore';

/**
 * Thin adapter over `useReportFiltersStore` for the AngularJS generic report engine.
 *
 * The `_state` object this factory used to own is now the store, so the generic engine
 * and the standard reports read the same filters — including "Show Matter Involving",
 * which they were already trying to sync through a third singleton in `filterService`.
 *
 * Delete this file when the generic engine is Vue. See
 * `docs/REPORT_REPLATFORMING_TRIAGE.md`.
 */
angular.module('leanlaw').factory('reportFilterService', [function () {
  const store = () => useReportFiltersStore(getPinia());
  return {
    setFilterState(state) {
      const next = state || {};
      const {
        scopeAccount,
        ...rest
      } = next;
      store().setFilters(rest);
      // Goes through the action so the "user has chosen" flag is set, which is what
      // stops the role default from overwriting a deliberate "no filter".
      if (Object.prototype.hasOwnProperty.call(next, 'scopeAccount')) {
        store().setScopeAccount(scopeAccount === undefined ? null : scopeAccount);
      }
    },
    getFilterState() {
      return store().filters;
    },
    queryFromFilter(show, visibleOnly = false) {
      return store().query(show, 'generic', visibleOnly);
    },
    getVisibleFilterState(show) {
      return store().visibleFilters(show);
    },
    options: () => {
      const s = store();
      return {
        billedOptions: s.billedOptions,
        statusOptions: s.archivedOptions,
        periodOptions: s.periodOptions
      };
    }
  };
}]);